import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import styles from "./style.module.scss";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import HomePageSectionsArrangementContext from "../../context/arrange-sections-page-home/context";
import HomePageSectionsArrangementTable from "../../components/arrange_sections_page_home/table";
import HomeHomePageSectionsArrangementContextProvider from "../../context/arrange-sections-page-home/provider";
import Can from "../../utils/rbac/can";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import SearchFilterCard from "../../components/general/filter-card";
interface IProps {
  children?: React.ReactNode;
}

const HomePageList: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();
  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(HomePageSectionsArrangementContext);


  useEffect(() => {
    actions.setSearch(search);
  }, [search]);
  
  useEffect(() => {
    actions.getData();
  }, [query, direction]);

  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("home_page_list")}
        subTitle={t("home_page_list_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
            <Button
              type="primary"
              onClick={() => {
                navigate(`/home-page-arrange/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_home_page_section")}
            </Button>
          </Can>,
        ]}
      />
      <SearchFilterCard
        formId="arrage-section-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      />
      <HomePageSectionsArrangementTable />
    </div>
  );
};

const HomeePageSectionsArrangementPage = () => {
  return (
    // ContextProvider
    <HomeHomePageSectionsArrangementContextProvider>
      <HomePageList />
    </HomeHomePageSectionsArrangementContextProvider>
  );
};
export default HomeePageSectionsArrangementPage;
